import React, { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';


import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';


function SendMailDialog(props) {
  
    
    const [emailAddress, setEmailAddress] = useState();

    useEffect(() =>  { //run once on page load   
      setEmailAddress(props.userName);
      
    },[])

    const handleOK = () => {
                
        props.onCompletionFunc(emailAddress); //calls the parent component's onCompletion function with the dialog result

        handleClose();
    };


    const handleCancel = () => {
      
      props.onCompletionFunc(false); //calls the parent component's onCompletion function with the dialog result

      handleClose();
  };

    const handleClose = () => {

        props.setDialogOpen(false);
    };

    
    const isEmailValid = (email) => {
      return String(email)
        .toLowerCase()
        .match(
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
    };


  

  return (
    <div>      
    
      <Dialog open={true} onClose={handleClose}  aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">Bekreft</DialogTitle>
        <DialogContent>            

          <DialogContentText>
            {props.dialogText}
          </DialogContentText>
          <br/>
          <TextField 
                defaultValue={props.userName}                
                inputProps={{style:{height: '15px',fontSize: '10pt',}}} 
                InputLabelProps={{style: {fontSize: 12}}}               
                variant="outlined" label="Epost" size='small'
                onChange={e => setEmailAddress(e.target.value)} >
                
            </TextField>  
          
        </DialogContent>

        <DialogActions>          
          <Button onClick={handleCancel} color="primary">
            Avbryt
          </Button>
          <Button onClick={handleOK} disabled={!isEmailValid(emailAddress)} color="primary">
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default SendMailDialog;